/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preset_Load_TitleInputs */

const en_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load Transcript Export Preset`)
};

const fr_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger un prereglage d'exportation de transcription`)
};

const de_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung zum Laden des Transkripts Exportieren`)
};

const it_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica preimpostazione di esportazione della trascrizione`)
};

const ru_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить предустановку экспорта транскрипта`)
};

const es_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar ajuste preestablecido de exportación de transcripción`)
};

const zh_cn2_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载转录导出预设`)
};

const ja_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトエクスポートプリセットを読み込む`)
};

const hi_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट एक्सपोर्ट प्रीसेट लोड करें`)
};

const pt_pt2_transcript_export_preset_load_title = /** @type {(inputs: Transcript_Export_Preset_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar transcrição Exportar predefinição`)
};

/**
* | output |
* | --- |
* | "Load Transcript Export Preset" |
*
* @param {Transcript_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_load_title = /** @type {((inputs?: Transcript_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_load_title(inputs)
	if (locale === "de") return de_transcript_export_preset_load_title(inputs)
	if (locale === "it") return it_transcript_export_preset_load_title(inputs)
	if (locale === "ru") return ru_transcript_export_preset_load_title(inputs)
	if (locale === "es") return es_transcript_export_preset_load_title(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_load_title(inputs)
	if (locale === "ja") return ja_transcript_export_preset_load_title(inputs)
	if (locale === "hi") return hi_transcript_export_preset_load_title(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_load_title(inputs)
	return en_transcript_export_preset_load_title(inputs)
});